import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for migrated `/trades/*` URLs (excluding bid-packages).
 *
 * Kept separate from `trades.ts` (the `RouteObject` tree) so `RouteUrls.ts` and pages can
 * import paths without creating a cycle through page `Component` imports.
 *
 * Nested routes compose from their parent's `.path` so the hierarchy stays visible and absolute
 * strings stay in sync (RR6 requires a child's path to start with its parent's).
 *
 * `/trades/bid-packages/*` lives in `bidPackagesPaths.ts`.
 */
export const tradesRoute = defineRoute("/trades");
export const tradesTradePartnersRoute = defineRoute(`${tradesRoute.path}/trade-partners`);
export const tradesPurchaseOrdersRoute = defineRoute(`${tradesRoute.path}/purchase-orders`);
export const tradesBidContractsRoute = defineRoute(`${tradesRoute.path}/bid-contracts`);
